type AllImagesObject = { [key: string]: string };

const getAllImagesObject = (r: __WebpackModuleApi.RequireContext): AllImagesObject => {
  const images: AllImagesObject = {};
  r.keys().forEach((item: string) => {
    const imgItem = r(item);
    // Добавляем проверку на существование default
    images[item.replace('./', '')] = imgItem.default || imgItem;
  });
  return images;
};

export const getImage = getAllImagesObject(
  require.context('./img/promo6', false, /\.(png|jpg|svg)$/)
);



